import React from 'react';
import { NOT_FOUND } from 'redux-first-router';
import { connect } from 'react-redux';
import universal from 'react-universal-component';

const Switcher = ({ page, location, pageData, properties, productCache }) => {
	if (properties.siteInitiated === false) return null;

	const path = decodeURIComponent(location.pathname);
	let currentPath = path.indexOf('#') !== -1 ? path.slice(0, path.indexOf('#')) : path;
	currentPath = currentPath.replace(/^\/[a-z]{2}\/?/, '');
	if (currentPath === '' || currentPath === '/') currentPath = 'start';
	if (location.type === NOT_FOUND) currentPath = '404';
	const data = pageData[currentPath];

	// Check if all data is available.
	if (!pageData || !data) return null;
	// Here we want to intercept "CatchAll" and read path API data to know which page to load.
	if (page === 'CatchAll') page = data.pageType ? data.pageType : 'page';
	if ((page.toLowerCase() === 'category') && Object.keys(productCache).length === 0) return null;

	let Route = null;

	switch (page.toLowerCase()) {
		default: {
			Route = universal(() => import('./Page/Page'));
			break;
		}
	}

	return <Route data={data} currentPath={currentPath} />;
};

const mapState = ({ page, location, pageData, environment, productCache }) => ({ page, location, pageData, properties: environment.properties, setup: environment.setup, productCache });

export default connect(mapState)(Switcher);
